<template>
  <div class="row align-items-center form-group" :class="classMarginEntity">
    <div class="col-2 text-right" :class="classColLabel" v-if="isDashboard">
      <img :src="iconCompany" alt="" width="45" height="45"/>
    </div>
    <div class="col-12" :class="classColLabel" v-else>
      <label :for="entitySelectorId" class="control-label">
        {{ entityLabel }}
      </label>
    </div>
    <div class="col-10 select-entity" :class="[classColSelect, selectEntityDashboard]">
      <multiselect v-if="entities" v-model="value"
        :id="entitySelectorId"
        :options="entities"
        label="name"
        track-by="id"
        :allow-empty="false"
        :showLabels="false"
        :disabled="disabled"
        :placeholder="$t('multiselect.placeholder')"
        :class="isDashboard ? 'arrow-multiselect' : ''"
        @input="onChangeValue">
      </multiselect>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import iconCompany from '@/assets/img/icons8-company-100.png'

export default {
  data() {
    return {
      value: null,
      iconCompany: iconCompany
    }
  },
  name: 'SelectEntity',
  components: { Multiselect },
  props: {
    entities: Array,
    preselectedEntityId: Number,
    labelEntity: String,
    entitySelector: String,
    colLabel: String,
    colSelect: String,
    marginEntity: String,
    disabled: { type: Boolean, default: false },
    isDashboard: Boolean
  },
  computed: {
    entitySelectorId() {
      return this.entitySelector || 'entity_selector'
    },
    entityLabel() {
      return this.labelEntity || this.$t("SelectEntity.label")
    },
    classColLabel() {
      return this.colLabel || 'col-md-5'
    },
    classColSelect() {
      return this.colSelect || 'col-md-3'
    },
    classMarginEntity() {
      return this.marginEntity || 'my-4'
    },
    selectEntityDashboard() {
      return this.isDashboard ? 'select-entity-dashboard' : ''
    }
  },
  watch: {
    entities: {
      immediate: true,
      handler(newValue) {
        if (newValue.length > 0 && !this.value) {
          this.setValueWithProps();
        }
      }
    },
    preselectedEntityId(newValue) {
      this.setValueWithProps()
    }
  },
  methods: {
    setValueWithProps() {
      this.value = this.entities.find(entity => entity.id == this.preselectedEntityId); 
    },
    onChangeValue() {
      this.$emit('entity-changed', this.value)
    }
  },
  mounted: function() {
    this.setValueWithProps();
  }
}
</script>

<style>
  .select-entity-dashboard {
    display: inline-flex;
  }
  .select-entity-dashboard .multiselect {
    color: #e51349
  }
</style>



// WEBPACK FOOTER //
// src/components/common/SelectEntity.vue